import { render, staticRenderFns } from "./paperList.vue?vue&type=template&id=243a080c&scoped=true"
import script from "./paperList.vue?vue&type=script&lang=js"
export * from "./paperList.vue?vue&type=script&lang=js"
import style0 from "./paperList.vue?vue&type=style&index=0&id=243a080c&prod&scoped=true&lang=less"
import style1 from "./paperList.vue?vue&type=style&index=1&id=243a080c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a080c",
  null
  
)

export default component.exports